import { getFileExtension } from "./generalUtils";
import moment from "moment";

export const lessThanFileSizeValidator = () => {
  const lessThanFileSize = (val, param) => {
    return parseFloat(val.size) <= parseFloat(param) ? true : false;
  };
  return {
    lessThanFileSize: {
      // name the rule
      message: "The :attribute must be less than or equal to :values.",
      rule: (val, params) => {
        if (val === null || val === "") return true;

        // for multiple files
        if (val instanceof Array) {
          for (let i = 0; i < val.length; i++) {
            if (!lessThanFileSize(val[i], params[0])) return false;
          }
        }
        // for single file
        else if (val instanceof Object) {
          return lessThanFileSize(val, params[0]);
        }
      },
      messageReplace: (message, params) =>
        message.replace(":values", parseFloat(params[0]) / 1024 / 1024 + "MB"), // optional
      required: true, // optional
    },
  };
};

export const fileTypeValidator = () => {
  const fileType = (val, params) => {
    return params.includes(getFileExtension(val.name).toLowerCase())
      ? true
      : false;
  };
  return {
    fileType: {
      // name the rule
      message: "The :attribute supports only :values.",
      rule: (val, params) => {
        if (val === null || val === "") return true;

        // for multiple files
        if (val instanceof Array) {
          for (let i = 0; i < val.length; i++) {
            if (!fileType(val[i], params)) return false;
          }
        }
        // for single file
        else if (val instanceof Object) {
          return fileType(val, params);
        }
      },
      messageReplace: (message, params) => message.replace(":values", params), // optional
      required: true, // optional
    },
  };
};

export const dateValidator = () => {
  return {
    minDate: {
      message: "The :attribute is greater than :value.",
      rule: (val, params) => {
        return moment(val) >= moment(params[0]);
      },
      messageReplace: (message, params) => message.replace(":value", params[0]),
    },
  };
};
